// Digital signature state of a document in the list: signed versions are kept even after edits.
export function hasSignedVersions(document) {
  return (document.signedVersions?.length ?? 0) > 0;
}

export function signatureStatus(document) {
  if (document.currentVersionSigned) {
    return { label: 'Assinado', color: 'success' };
  }
  if (hasSignedVersions(document)) {
    return { label: 'Alterado após a assinatura', color: 'warning' };
  }
  return { label: 'Não assinado', color: 'default' };
}

export const SIGN_DISABLED_REASON =
  'Esta versão já foi assinada. Altere o documento para assinar uma nova versão.';

export const DELETE_DISABLED_REASON =
  'Documentos com versões assinadas digitalmente não podem ser excluídos.';
